/*
  Project: Casalmon
  Author: xfive
 */

import './modules/lazyload';
import './modules/hero-scroll';
import ImageCredits from './modules/image-credits';
import NewsList from './modules/news-list';
import './modules/partners';
import './modules/focus-outline';
import Expandable from './modules/expandable';
import './modules/statewide-status';
import './modules/navigation';
import './modules/restoration-solutions';
import './modules/restoration-solutions-snapshot';
import './modules/page-bg-parallax';
import SalmonRivers from './modules/salmon-rivers';
import './modules/rivers-dropdown';
import Tabs from './modules/tabs';
import './modules/status-boxes';

const expandable = new Expandable();
expandable.init();
const tabs = new Tabs();
tabs.init();
const newsList = new NewsList();
newsList.init();
const salmonRivers = new SalmonRivers();
salmonRivers.init();
const imageCredits = new ImageCredits();
imageCredits.init();



// WEBPACK FOOTER //
// ./src/scripts/app.js